import React from 'react';

import SelectFilter from 'components/search_sidebar/select_filter';

import { activityTypes } from 'bundles/apex/activities/type/config';

import type { Filters } from './types';

interface Option {
  label: string;
  value: string;
}

const options: Option[] = [
  { label: 'All Types', value: 'all' },
  { label: 'None', value: 'none' },
  ...Object.values(activityTypes).map(({ key, label }) => ({ label, value: key })),
];

type Slice = Pick<Filters, 'type'>;
interface Props extends Slice {
  onChange: (changes: Slice) => void;
}

export default function TaskTypeFilter({ type, onChange }: Props) {
  const value = options.find(option => option.value === type) ?? options[0];

  return (
    <SelectFilter
      autoWidth
      options={options}
      value={value}
      onChange={(option: Option) => onChange({ type: option.value })}
    />
  );
}
